import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  standalone: false,
})
export class LoggedOutComponent {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  public isAuthenticated = signal<boolean>(false);

  constructor() {
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.isAuthenticated.set(true);
        this.route.data.subscribe((data) => {
          const returnTo = data?.returnTo || window.location.origin + '/logged-out';
          this.authService.logout({ logoutParams: { returnTo } });
        });
      }
    });
  }
}
